var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-input",attrs:{"contenteditable":"true","data-placeholder":this.showPlaceholder ? _vm.placeholder : ''},domProps:{"innerHTML":_vm._s(_vm.valueModel)},on:{"input":_vm.updateHtml,"blur":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }